@if(showModal()) {
  <tds-modal
    #countdownModal
    header="Warning"
    size="xs"
    show
    actions-position="static"
    prevent="true"
    closable="false"
    tds-alert-dialog="dialog"
  >
    <div class="redirect-container" slot="body">
      <h2>You will be redirected to the login page</h2>
      <div class="countdown">
        <span>{{ seconds() }} seconds before automatic redirection</span>
        <span class="ellipsis">{{ ellipsis() }}</span>
      </div>
    </div>
  </tds-modal>
}
